//todo why are we importing? RoleControllerApi from acc-rest-client this file does not have this method.
import {
    Configuration,
    RoleControllerApi
} from "acc-rest-client";
import environments from "../utils/environments";
import {getAuthenticatedUser} from "../utils/authHelper";

class RoleRestClient {

    constructor() {
    }

    accessToken = () => {
        return getAuthenticatedUser()?.access_token;
    };

    configuration = () => {
        const openapiConfig = new Configuration();
        openapiConfig.baseOptions = {
            headers: { Authorization: 'Bearer ' + this.accessToken() },
        };
        openapiConfig.basePath = environments.apiUrl;
        return openapiConfig;
    };

    rolesApi = () => {
        return new RoleControllerApi(this.configuration());
    };
}

export default RoleRestClient;
